export const TEXTAREA_MAX_LENGTH = 9000
export const TEXT_MAX_LENGTH = 512
